import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Container,
  Card,
  CardHeader,
  CardBody,
  Spinner,
  Alert,
  Button,
} from "reactstrap";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ClientLeadsData = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [leadsData, setLeadsData] = useState([]);

  useEffect(() => {
    fetchLeadsData();
  }, []);

  const fetchLeadsData = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://api.hanoch.in/users/client-leads/");
      console.log("client", response);
      setLeadsData(response || []);
      setSuccess("Data fetched successfully!");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Failed to fetch client leads. Please try again."
      );
      setTimeout(() => setError(""), 3000);
    } finally {
      setLoading(false);
    }
  };

  // 📤 Export Excel Function
  const exportToExcel = () => {
    if (!leadsData.length) return;

    // Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(leadsData);

    // Create a workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ClientLeads");

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "ClientLeads.xlsx");
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "#080808ff",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        zIndex: 9999,
        overflowY: "auto",
        padding: "22px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Container fluid className="mt-4">
        <Card>
          <CardHeader className="bg-black text-white d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Client Leads Table</h5>
            {/* ✅ Export Button */}
            <Button color="success" size="sm" onClick={exportToExcel}>
              Export Excel
            </Button>
          </CardHeader>
          <CardBody>
            {loading && <Spinner color="primary" />}
            {error && <Alert color="danger">{error}</Alert>}
            {success && <Alert color="success">{success}</Alert>}
            <Table bordered hover responsive>
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Date and time</th>
                  <th>Name</th>
                  <th>Company</th>
                  <th>Phone</th>
                  <th>Remarks</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {leadsData.length > 0 ? (
                  leadsData.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row?.created_at ? new Date(row.created_at).toLocaleString() : "-"}</td>
                      <td>{row?.name}</td>
                      <td>{row?.company}</td>
                      <td>{row?.phone}</td>
                      <td>{row?.remarks}</td>
                      <td>{row?.email}</td>
                     
                    </tr>
                  ))
                ) : (
                  !loading && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        No data available
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default ClientLeadsData;
